import React, { useState } from "react";
import { useGetUserProfileQuery } from "../../../rtk-query/slices/profile/profileSlice";
import SupplierTypeTabContent from "../../onboarding/_components/OBTabsScreens/SupplierTypeTabContent";
import PersonalDetailsTabContent from "../../onboarding/_components/OBTabsScreens/PersonalDetailsTabContent";
import EditProfileSidebar from "./EditProfileSidebar";
import EPSupplierTypeTabContent from "./EPSupplierTypeTabContent";
import EPBusinessDetailsTabContent from "./EPBusinessDetailsTabContent";
import EPExperienceOfferedTabContent from "./EPExpereinceOfferedTabContent";
import EPPersonalDetailsTabContent from "./EPPersonalDetailsTabContent";
import EPAccountDetailsTabContent from "./EPAccountDetailsTabContent";

function EditProfileMainWrapper() {
  const [activeComponent, setActiveComponent] = useState(
    localStorage.getItem("DODEditProfileActiveComponent")
      ? parseInt(localStorage.getItem("DODEditProfileActiveComponent"))
      : 1
  );
  const { data: userInfo, isLoading: isUserInfoLoading } =
    useGetUserProfileQuery();

  const renderComponent = () => {
    switch (activeComponent) {
      case 1:
        return (
          <EPSupplierTypeTabContent
            setCurrentTab={setActiveComponent}
            userInfo={userInfo?.data}
          />
        );
      case 2:
        return (
          <EPBusinessDetailsTabContent
            setCurrentTab={setActiveComponent}
            userInfo={userInfo?.data}
          />
        );
      case 3:
        return (
          <EPExperienceOfferedTabContent
            setCurrentTab={setActiveComponent}
            userInfo={userInfo?.data}
          />
        );
      case 4:
        return (
          <EPPersonalDetailsTabContent
            setCurrentTab={setActiveComponent}
            userInfo={userInfo?.data}
          />
        );
      case 5:
        return (
          <EPAccountDetailsTabContent
            setCurrentTab={setActiveComponent}
            userInfo={userInfo?.data}
          />
        );
      default:
        return (
          <EPSupplierTypeTabContent
            setCurrentTab={setActiveComponent}
            userInfo={userInfo?.data}
          />
        );
    }
  };

  return (
    <div className="dod-product-listing-main-wrapper">
      {/* title and create product button */}
      <div className="w-100 d-flex align-items-center justify-content-between">
        <h2 className="ob-supplier-content-heading">Edit Profile</h2>
      </div>

      {/* Layout with sidebar and content */}
      <div className=" ps-0 pe-0 mb-5 pb-5 d-flex flex-md-row flex-column align-items-start justify-content-start gap-md-0 gap-5">
        {/* Sidebar */}
        <EditProfileSidebar
          activeComponent={activeComponent}
          setActiveComponent={setActiveComponent}
          userInfo={userInfo?.data}
        />

        {/* Content */}
        <div
          className="usr-p-content-wrapper"
          style={{ flex: 1, padding: "0px 20px" }}
        >
          {renderComponent()}
        </div>
      </div>
    </div>
  );
}

export default EditProfileMainWrapper;
